const config: { [key: string]: any } = {};

config.serverUrl = '';
config.ICE_SERVER_URL = '/api/v1/ice-servers';

export default config;
